<div class="">
  <div class="header" (swipedown)="swipe($event.type)">
    <div class="title">
      <p>تبریک !</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="body">
    <div class="container">
      <ng-lottie
        width="59px"
        height="56px"
        [options]="options"
        [containerClass]="'lottie'"
        (animationCreated)="animationCreated($event)"
      ></ng-lottie>
      <p>
        {{ text }}
      </p>
    </div>
    <div class="button" (click)="goBack()">متوجه شدم</div>
  </div>
</div>
